import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiFetch } from '../lib/api';

export default function PurchaseOrderDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [po, setPo] = useState(null);
  const [msg, setMsg] = useState('');

  async function load() {
    const res = await apiFetch(`/api/pos/${id}`);
    if (res.ok) { const d = await res.json(); setPo(d.purchase_order); }
    else if (res.status === 404) { setMsg('Purchase order not found.'); }
  }
  useEffect(() => { load(); }, [id]);

  function fmtMoney(n, cur) {
    if (n == null) return '—';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format(n); }
    catch { return String(n); }
  }
  function fmtDate(s) { if (!s) return '—'; try { return new Date(s).toLocaleDateString(); } catch { return '—'; } }
  function fmt(s) { if (!s) return '—'; try { return new Date(s).toLocaleString(); } catch { return '—'; } }

  if (msg && !po) return <div className="hq-page-content"><div className="hq-page-head"><h1>Purchase Orders</h1><p>{msg}</p></div></div>;
  if (!po) return <div className="hq-page-content"><div className="hq-page-head"><p>Loading…</p></div></div>;

  return (
    <div className="hq-page-content">
      <div className="hq-page-head">
        <h1>PO {po.po_number || ''}</h1>
        <p>{po.vendor_name || 'Unknown vendor'} · {po.status || 'open'}</p>
      </div>

      <div className="hq-panel" style={{ marginBottom: 20 }}>
        <div className="hq-panel-head"><h2>Details</h2></div>
        <table className="hq-table">
          <tbody>
            <tr><td className="hq-role">PO number</td><td>{po.po_number || '—'}</td></tr>
            <tr><td className="hq-role">Reference</td><td>{po.reference_number || '—'}</td></tr>
            <tr>
              <td className="hq-role">Vendor</td>
              <td>
                {po.vendor_local_id
                  ? <button className="hq-linkish" onClick={() => navigate(`/vendors/${po.vendor_local_id}`)}>{po.vendor_name || '—'}</button>
                  : (po.vendor_name || '—')}
              </td>
            </tr>
            <tr><td className="hq-role">Status</td><td>{po.status || '—'}</td></tr>
            <tr><td className="hq-role">Billed status</td><td>{po.billed_status || '—'}</td></tr>
            <tr><td className="hq-role">Order date</td><td>{fmtDate(po.order_date)}</td></tr>
            <tr><td className="hq-role">Delivery date</td><td>{fmtDate(po.delivery_date)}</td></tr>
            <tr><td className="hq-role">Total</td><td>{fmtMoney(po.total, po.currency_code)}</td></tr>
            <tr><td className="hq-role">Last synced</td><td>{fmt(po.last_synced_at)}</td></tr>
            <tr><td className="hq-role">Zoho PO ID</td><td>{po.zoho_po_id || '—'}</td></tr>
          </tbody>
        </table>
      </div>

      <div className="hq-panel" style={{ marginBottom: 20 }}>
        <div className="hq-panel-head"><h2>Line items</h2></div>
        <div style={{ overflowX: 'auto' }}>
        <table className="hq-table">
          <thead><tr><th>SKU</th><th>Item</th><th>Description</th><th>Qty</th><th>Invoiced</th><th>Unit</th><th>Rate</th><th>Tax</th><th>Total</th></tr></thead>
          <tbody>
            {(po.line_items || []).map((li, idx) => (
              <tr key={idx}>
                <td>{li.sku || '—'}</td>
                <td>{li.name || '—'}</td>
                <td style={{ color: 'var(--hq-muted)' }}>{li.description || '—'}</td>
                <td>{li.quantity != null ? li.quantity : '—'}</td>
                <td>{li.quantity_invoiced != null ? li.quantity_invoiced : '—'}</td>
                <td>{li.unit || '—'}</td>
                <td>{fmtMoney(li.rate, po.currency_code)}</td>
                <td>{li.tax_name ? `${li.tax_name}${li.tax_percentage != null ? ` (${li.tax_percentage}%)` : ''}` : '—'}</td>
                <td>{fmtMoney(li.item_total, po.currency_code)}</td>
              </tr>
            ))}
            {(!po.line_items || po.line_items.length === 0) && (
              <tr><td className="hq-empty" colSpan={9}>No line items cached. Refresh from Zoho on the PO list.</td></tr>
            )}
          </tbody>
        </table>
        </div>
      </div>

      <button className="hq-signout" style={{ width: 'auto', padding: '0 16px' }} onClick={() => navigate('/purchase-orders')}>Back</button>
    </div>
  );
}
